import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  styleUrl: './spinner.component.scss',
  template: `
    @if (loading()) {
      <p-progress-spinner ariaLabel="loading" />
    }
  `,
})
export class SpinnerComponent {
  loading = input.required<boolean>();
}
